import { createSelector } from '@reduxjs/toolkit';
import { computeRollup } from './quoteRollup';
export const selectQuoteItems = (state) => state.quote.items;
// Memoized so the rollup object is recomputed only when the line items change,
// not on every dispatched action — a search must not re-render the rail.
export const selectQuoteRollup = createSelector(selectQuoteItems, (items) => computeRollup(items));
